import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import { Award } from "lucide-react";
import { IMAGES } from "@/config";
import { Reveal, Highlight, ImageSlot } from "./Primitives";

const CREDS = [
  "15 years in banking with ICICI Bank, Kotak Mahindra, SBI Card, Standard Chartered & more",
  "Trained 80,000+ students across India",
  "Shared the stage with Robert Kiyosaki at Growth Summit India 2023",
  "Author of Amazon #1 bestseller \"Wealth Mastery\" and \"Power of Compounding\"",
  "Forbes India Top 30 visionaries",
];
const STATS = [[16000, "+", "Students Trained"], [15, "+", "Years in Banking"], [3, "", "Books Authored"]];

const Counter = ({ to, suffix, label, i }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, to, { duration: 1.8, ease: "easeOut", onUpdate: (v) => setVal(Math.round(v)) });
    return () => c.stop();
  }, [inView, to]);
  return (
    <div ref={ref} className="rounded-xl border border-white/20 bg-white/5 px-2 py-3 text-center" data-testid={`mentor-stat-${i}`}>
      <div className="font-black text-xl sm:text-3xl text-white tabular-nums">{val.toLocaleString("en-IN")}{suffix}</div>
      <div className="text-[11.5px] sm:text-[12.5px] text-white/75 mt-1">{label}</div>
    </div>
  );
};

export const Mentor = () => (
  <section className="mentor-bg px-4 py-14 sm:py-20 text-white overflow-hidden" data-testid="mentor-section">
    <div className="max-w-5xl mx-auto">
      <Reveal>
        <h2 className="font-black uppercase text-center text-[24px] sm:text-[34px]">Meet Your <Highlight>Mentor</Highlight></h2>
      </Reveal>
      <div className="grid md:grid-cols-[1.2fr_1fr] gap-8 md:gap-12 mt-8 items-center">
        <Reveal className="order-2 md:order-1">
          <h3 className="font-extrabold text-2xl sm:text-3xl" data-testid="mentor-name">Sandeep Gupta</h3>
          <p className="text-tang-light font-semibold text-[13.5px] sm:text-sm mt-1">Financial Freedom Coach | Ex-Banker | TEDx Speaker</p>
          <ul className="mt-5 space-y-3">
            {CREDS.map((c) => (
              <li key={c} className="flex gap-2.5 text-[13.5px] sm:text-[14.5px] text-white/90 leading-snug">
                <Award className="w-[18px] h-[18px] text-tang shrink-0 mt-0.5" />{c}
              </li>
            ))}
          </ul>
          <div className="grid grid-cols-3 gap-2.5 sm:gap-4 mt-7">
            {STATS.map(([to, s, l], i) => <Counter key={l} to={to} suffix={s} label={l} i={i} />)}
          </div>
        </Reveal>
        <Reveal delay={0.15} className="order-1 md:order-2">
          <div className="relative mx-auto max-w-[360px] aspect-[4/5]">
            <div className="absolute inset-0 rounded-full bg-plum blur-3xl opacity-60" aria-hidden />
            <div className="relative w-full h-full rounded-[28px] overflow-hidden ring-1 ring-white/20">
              <ImageSlot dark src={IMAGES.mentor} label="Second photo of Sandeep Gupta (portrait)" alt="Sandeep Gupta speaking on stage" position="44% center" testId="mentor-image-slot" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
